import React from "react";
import {
  Button,
  FlexDirectionRow,
  FormContainer,
  FormInputContainer,
  MainContent,
  SubTitle,
} from "../../../../../components/StyledComponents";
import "./styles.module.scss";
import { VersaoAppService } from "../../../services/versaoAppService";
import { handleModalStatus } from "../../../../../utils/handleModalStatus";
import { BaSeDialogContext } from "@base/react";
import {
  maxLength,
  minLength,
  valueIsRequired,
} from "../../../../../utils/regex";
import Input from "../../../../../components/InputControlled";
import { useForm } from "react-hook-form";
import Select from "../../../../../components/Select";
import { useApp } from "../../../../../context/app";

export const IncluirVersaoApp = () => {
  const { setRenderIncludeScreen } = useApp();
  const { control, handleSubmit, reset } = useForm({
    defaultValues: {
      plataforma: '',
      versao: '',
    },
  });

  const { showModal } = React.useContext(BaSeDialogContext);

  const handleGoHome = () => {
    setRenderIncludeScreen(false);
  };

  const sendRequest = async (dataForm) => {
    console.log("dataForm", dataForm);
    try {
      const body = {
        ...dataForm,
        status: "PENDENTE",
      };
      const response = await VersaoAppService.save(body);
      console.log("response", response);
      handleModalStatus({
        type: "success",
        msgOnSuccess: "Versão APP adicionada com sucesso.",
        onCloseModal: handleGoHome,
        showModal,
      });
    } catch (e) {
      handleModalStatus({
        type: "error",
        showModal,
      });
    }
  };
  
  const onResetFields = () => {
    reset()
  }

  return (
    <MainContent>
      <SubTitle>
        <h3>Incluir</h3>
      </SubTitle>

      <FormContainer
        style={{ displayFlex: true, flexDirection: "column" }}
        onSubmit={handleSubmit(sendRequest)}
      >
        <FormInputContainer>
          <Select
            name="plataforma"
            placeholder="Loja"
            options={["ANDROID", "IOS"]}
            control={control}
            rules={{ ...valueIsRequired() }}
          />
        </FormInputContainer>

        <FormInputContainer>
          <Input
            required={true}
            maxLength={20}
            minLength={3}
            name="versao"
            control={control}
            rules={{ ...valueIsRequired(), ...maxLength(20), ...minLength(3) }}
            placeholder={"Versão"}
          />
        </FormInputContainer>

        <FlexDirectionRow position={"end"} style={{ marginRight: "40px" }}>
          <Button
              type="button"
              backgroundColor={"#9CA2A8"}
              onClick={onResetFields}
              style={{
                marginRight: '20px'
              }}
          >
            Limpar
          </Button>
          
          <Button href="#" type="submit">
            Incluir versão
          </Button>
        </FlexDirectionRow>
      </FormContainer>
    </MainContent>
  );
};
